"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorToString = void 0;
const errorToString = (error) => {
    var _a;
    return error instanceof Error
        ? error.message
        : (_a = error === null || error === void 0 ? void 0 : error.toString()) !== null && _a !== void 0 ? _a : 'No error message provided.';
};
exports.errorToString = errorToString;
//# sourceMappingURL=errorToString.js.map